// Turns bare URLs in a markdown draft into autolinks before the composer parses it.

/** A bare http(s) URL: not already a link target `](…)`, an autolink `<…>`, link text `[…` or inline code. */
const BARE_URL = /(?<![(<[`])\bhttps?:\/\/[^\s<>()[\]`]+/g;

/** Sentence punctuation that ends a URL in prose rather than belonging to it. */
const TRAILING_PUNCTUATION = /[.,;:!?'"]+$/;

/** A matched URL without the sentence punctuation that followed it. */
export const trimUrlPunctuation = (match: string): string => match.replace(TRAILING_PUNCTUATION, '');

/**
 * The composer's markdown parser has linkify off, so a bare URL in an AI draft loads as plain
 * text and stays unclickable. Wrapping it as `<url>` loads it as a link; the serializer already
 * writes a link whose text is its URL back as `<url>`, so the saved draft round-trips.
 */
export function linkBareUrls(markdown: string): string {
  return markdown.replace(BARE_URL, (match) => {
    const url = trimUrlPunctuation(match);
    return `<${url}>${match.slice(url.length)}`;
  });
}
